import React, { useState } from "react";
import "./Platform.css";
import { FaFileAlt, FaUsersCog } from "react-icons/fa";
import { MdSettings } from "react-icons/md";
import landing8 from "../../../../images/landing8.webp";

// Data for tabs + 4 cards each
const featuresData = {
    "Job management": [
        {
            icon: <FaFileAlt size={40} />,
            title: "AI-Assisted JD Creation",
            text: "Generate tailored job descriptions in seconds using AI trained on industry standards.",
        },
        {
            icon: <FaFileAlt size={40} />,
            title: "JD Version Control",
            text: "Track changes, collaborate with hiring managers, and maintain multiple versions easily.",
        },
        {
            icon: <MdSettings size={40} />,
            title: "Job Visibility Settings",
            text: "Control who can view, edit, or apply to specific job postings across platforms.",
        },
        {
            icon: <FaUsersCog size={40} />,
            title: "ATS Integration",
            text: "Seamlessly sync with your existing applicant tracking system for a smooth workflow.",
        },
    ],
    "Talent Sourcing & Pooling": [
        {
            icon: <MdSettings size={40} />,
            title: "Smart Candidate Matching",
            text: "Leverage AI to instantly identify the most relevant candidates for each role.",
        },
        {
            icon: <FaUsersCog size={40} />,
            title: "Talent Pool Management",
            text: "Build and nurture your private talent pipeline for future hiring needs.",
        },
        {
            icon: <FaFileAlt size={40} />,
            title: "Resume Parsing",
            text: "Automatically extract skills, experience, and qualifications from uploaded resumes.",
        },
        {
            icon: <MdSettings size={40} />,
            title: "Sourcing Analytics",
            text: "Gain insights into sourcing performance and identify your best candidate channels.",
        },
    ],
    "Candidate Evaluation": [
        {
            icon: <MdSettings size={40} />,
            title: "Skill-Based Assessments",
            text: "Measure technical and soft skills with customizable assessments built for accuracy.",
        },
        {
            icon: <FaUsersCog size={40} />,
            title: "Structured Interview Tools",
            text: "Standardize interviews with guided questions, scoring rubrics, and evaluation forms.",
        },
        {
            icon: <FaFileAlt size={40} />,
            title: "Automated Scoring",
            text: "Reduce bias with AI-generated candidate scores based on objective performance data.",
        },
        {
            icon: <MdSettings size={40} />,
            title: "Video Interviews",
            text: "Conduct live or asynchronous interviews with integrated recording and playback.",
        },
    ],
    "Assessment Analytics": [
        {
            icon: <FaFileAlt size={40} />,
            title: "Performance Insights",
            text: "Track strengths and weaknesses of candidates across skill categories at a glance.",
        },
        {
            icon: <MdSettings size={40} />,
            title: "Custom Reports",
            text: "Generate tailored reports for hiring managers or clients with a single click.",
        },
        {
            icon: <FaUsersCog size={40} />,
            title: "Benchmarking",
            text: "Compare candidate results against role-specific or industry-wide benchmarks.",
        },
        {
            icon: <FaFileAlt size={40} />,
            title: "Trend Analysis",
            text: "Identify long-term hiring patterns and predict future workforce needs.",
        },
    ],
};

const Platform = () => {
    const [activeTab, setActiveTab] = useState("Job management");

    return (
        <section
            style={{
                background: `linear-gradient(rgba(255,255,255,0.95), rgba(255,255,255,0.95)), url(${landing8})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            className="platform-section"
        >
            {/* Heading */}
            <h2 className="platform-heading">Comprehensive Platform Features</h2>
            <p className="platform-subheading">
                Empower your hiring teams with AI-driven tools for faster, fairer, and more effective recruitment.
            </p>

            {/* Tabs */}
            <div className="platform-tabs">
                {Object.keys(featuresData).map((tab) => (
                    <div
                        key={tab}
                        className={`tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>

            {/* Feature Cards */}
            <div className="platform-cards">
                {featuresData[activeTab].map((card, index) => (
                    <div className="platform-card" key={index}>
                        <div className="feature-icon">{card.icon}</div>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Platform;
